import { connectionData, endpoint } from "./apiConnection";

export const addCuotaByAlumno = async (body) => connectionData(endpoint,'cuotas','POST',body);
export const dataCuotas = async () => connectionData(endpoint,'cuotas','GET');
export const dataCuota = async (cuotaId) => connectionData(endpoint,'cuota/'+cuotaId,'GET');
export const dataCuotasAbril = async () => connectionData(endpoint,'cuotas/abril','GET');
export const dataCuotasMarzo = async () => connectionData(endpoint,'cuotas/marzo','GET');
export const dataCuotasMayo = async () => connectionData(endpoint,'cuotas/mayo','GET');
export const dataCuotasJunio = async () => connectionData(endpoint,'cuotas/junio','GET');
export const dataCuotasJulio = async () => connectionData(endpoint, 'cuotas/julio', 'GET');
export const dataCuotasAllMonth = async () => connectionData(endpoint,'cuotas/month','GET');
export const updateCuotas = async ( idCuota , newStatus ) => connectionData(endpoint,'cuotas/update/'+idCuota,'PUT', {newStatus:newStatus});